export default __webpack_public_path__ + "static/media/github.2313f606.svg";